<template>
  <h1>Sample Search</h1>
  <Suspense>
    <template #default>
      <AlgoSearch />
    </template>
    <template #fallback>
      <div>Loading...</div>
    </template>
  </Suspense>
</template>

<script>
import AlgoSearch from "./components/AlgoSearch";

export default {
  name: "App",
  components: {
    AlgoSearch,
  },
};
</script>

<style>
</style>
